export default __webpack_public_path__ + "static/media/image2.30fec960.png";